module.exports = __webpack_public_path__ + "img/entertainment-green.70988386.jpg";